export const texts = {
    title: "home.page.addonPopup.title",
    description: "home.page.addonPopup.description",
    ctaButton: "home.page.addonPopup.ctaButton",
    remindMeLaterButton: "home.page.addonPopup.remindMeLaterButton",
};
